import { defineStore } from 'pinia';

// 新资金流放量开关
export const useCommonStore = defineStore('commonStore', {
  state: () => ({
    isTest: false,
    isUnauth: false,
    currentUnit: 'R$',
  }),
  actions: {
    setCurrentUnit(currentUnit: string) {
      this.currentUnit = currentUnit;
    },
    setIsUnauth(currentUnauth: boolean) {
      this.isUnauth = currentUnauth;
    },
    setIsTest(currentTest: boolean) {
      this.isTest = currentTest;
    },
  },
});
